<article class="cm-media-article">
  <a href="{{ link }}" target="_blank" class="cm-media-article-inner">
    <img src="{{ imgSrc }}" alt="{{ imgAlt | translate }}" class="cm-media-article-image" />
    <span class="cm-blue-tag">{{ source }}</span>
    <h3 class="cm-media-article-title">{{ heading | translate }}</h3>
    <p class="cm-paragraph">{{ text | translate }}</p>
  </a>
</article>
